import { GET_ORDER_ITEMS } from '../actionTypes/OrderActionTypes';

export default function OrderItemsReducer(state = [], action) {
    // NOSONAR
    switch (
        action.type // NOSONAR
    ) {
        case GET_ORDER_ITEMS:
            return action.payload;
        default:
            return state;
    }
}
